import { FadeUp } from "./Reveal";
import { scrollToSection } from "@/hooks/useLenis";

export const PACKAGES = [
  {
    name: "The Intimate",
    tag: "Elopements & city halls",
    features: ["250+ edited frames", "Private online gallery", "Delivered in 3 weeks", "Flight tickets included"],
  },
  {
    name: "The Signature",
    tag: "The full wedding day",
    features: ["600+ edited frames", "Engagement session", "Fine-art preview box", "In 4 weeks", "Flight tickets included"],
    featured: true,
  },
  {
    name: "The Editorial",
    tag: "Weekends & destinations",
    features: ["1000+ edited frames", "35mm film add-on included", "Flight tickets included"],
  },
];

export const Pricing = () => (
  <section id="collections" className="px-6 md:px-12 py-28 md:py-44 bg-[#0A0A0A]" data-testid="pricing-section">
    <FadeUp className="mb-16 md:mb-24">
      <p className="text-xs tracking-[0.4em] uppercase text-[#C9A26B] mb-4">Collections</p>
      <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl tracking-tighter text-[#F5F4F0] leading-[1.05] max-w-3xl">
        Three ways to <span className="font-accent italic text-[#C9A26B]">remember everything</span>
      </h2>
    </FadeUp>

    <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
      {PACKAGES.map((p, i) => (
        <FadeUp key={p.name} delay={i * 0.1}>
          <article
            data-testid={`package-card-${i}`}
            className={`group relative h-full flex flex-col p-10 md:p-12 border transition-colors duration-500 ${
              p.featured
                ? "bg-[#121212] border-[#C9A26B]/60"
                : "bg-transparent border-white/10 hover:border-[#C9A26B]/40"
            }`}
          >
            {p.featured && (
              <span className="absolute -top-3 left-10 bg-[#C9A26B] text-[#0A0A0A] text-[10px] tracking-[0.3em] uppercase px-3 py-1">
                Most loved
              </span>
            )}
            <p className="text-xs tracking-[0.3em] uppercase text-[#525252] mb-8">{p.tag}</p>
            <h3 className="font-serif text-3xl tracking-tight text-[#F5F4F0] mb-2">{p.name}</h3>
            <p className="font-accent italic text-2xl text-[#C9A26B] mb-10">On enquiry</p>
            <ul className="flex-1 flex flex-col gap-4 mb-12">
              {p.features.map((f) => (
                <li key={f} className="flex items-start gap-3 text-sm text-[#A3A3A3] leading-relaxed">
                  <span className="mt-2 w-4 h-px bg-[#525252] shrink-0" />
                  {f}
                </li>
              ))}
            </ul>
            <button
              data-testid={`package-select-${i}`}
              onClick={() => scrollToSection("#book")}
              className={`text-xs tracking-[0.3em] uppercase py-4 border transition-colors duration-400 ${
                p.featured
                  ? "bg-[#C9A26B] text-[#0A0A0A] border-[#C9A26B] hover:bg-transparent hover:text-[#C9A26B]"
                  : "border-white/30 text-[#F5F4F0] hover:bg-[#C9A26B] hover:border-[#C9A26B] hover:text-[#0A0A0A]"
              }`}
            >
              Enquire
            </button>
          </article>
        </FadeUp>
      ))}
    </div>

    <FadeUp delay={0.2} className="mt-16 md:mt-20 flex items-start gap-4 max-w-2xl">
      <span className="mt-2.5 w-8 h-px bg-[#C9A26B] shrink-0" />
      <p className="text-sm md:text-base text-[#A3A3A3] leading-relaxed" data-testid="pricing-enquiry-note">
        Every wedding is one of a kind, and so is every quote. For prices, availability
        and anything else you'd like to know, send us an enquiry — we'll reply personally within 48 hours.
      </p>
    </FadeUp>
  </section>
);
